import {
  clinicianUpgradeModalOpenAtom,
  upgradeProModalOpenAtom,
} from '@/atoms/paywallAtoms';
import { IS_EVIDENCE_LAUNCH_TRIAL_AND_UPGRADE_FLOWS_ENABLED } from '@/components/constants/flags';
import type { SetStateAction, WritableAtom } from 'jotai';
import { getDefaultStore } from 'jotai';

type BooleanWritableAtom = WritableAtom<boolean, [SetStateAction<boolean>], void>;

export type MinimalJotaiStore = {
  set: (atom: BooleanWritableAtom, update: SetStateAction<boolean>) => void;
};

export function openQuotaExceededUpgradeModal(store?: MinimalJotaiStore) {
  const jotaiStore = store ?? getDefaultStore();
  if (IS_EVIDENCE_LAUNCH_TRIAL_AND_UPGRADE_FLOWS_ENABLED()) {
    jotaiStore.set(clinicianUpgradeModalOpenAtom, true);
  } else {
    jotaiStore.set(upgradeProModalOpenAtom, true);
  }
}
